import { useEffect, useState } from "react";
import classNames from "../../../utils/classNames";
import { DateTime } from 'luxon';
import formatDateTime from "../../../utils/formatDateTime";

export default function DailyIntervalSelector({ getValues }) {
  const [time, setTime] = useState(null);

  useEffect(() => {
    const startDateTime = getValues("trigger.startDateTime");
    if (!startDateTime) return;

    const startTime = formatDateTime(startDateTime, DateTime.TIME_SIMPLE);
    setTime(startTime);
  }, [getValues("trigger.startDateTime")])


  return (
    <div className="mt-6 flex items-center gap-x-2">
      {time && (
        <div className="space-x-2">
          <span>{time}</span>
          <span className="text-sm text-gray-700">
            (From Start Date and Time)
          </span>
        </div>
      )}
    </div>
  )

}